import { Component, Input } from '@angular/core';
import { EColors } from 'src/app/admin/enums/colors.enum';
import { EExpands } from 'src/app/admin/enums/expands.enum';
import { EFills } from 'src/app/admin/enums/fills.enum';
import { EShapes } from 'src/app/admin/enums/shapes.enum';
import { ESlots } from 'src/app/admin/enums/slots.enum';
import { IButtonSettings } from 'src/app/admin/models/button.interface';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent  {
  @Input() label!: string;
  @Input() settings: IButtonSettings = {
    fill: EFills.Default,
    expand: EExpands.Default,
    shape: EShapes.Default,
    color: EColors.Lime,
    disabled: false,
    icon: { slot: ESlots.None, name: 'star' }
  };
}
